module.exports = __webpack_public_path__ + "img/io-10.bedb99ea.png";